export default "/react/checkmark-ba37792a.png";